
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { Model, ModelProperty } from 'models/Model';


export class QualificationCallOverviewModel extends Model<QualificationCallOverviewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskActionId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'companyName', type: 'string' },
		{ name: 'totalPrice', type: 'number' },
		{ name: 'business', type: 'string' },
		{ name: 'sellerId', type: 'string' },
		{ name: 'salesTeamId', type: 'string' },
		{ name: 'signDate', type: 'Date' },
		{ name: 'products', type: 'OrderLineModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } }
	];
	[key: string]: any;
	
	public taskActionId?: string;
	public taskflowId?: string;
	public companyName: string;
	public totalPrice: number;
	public business: string;
	public sellerId?: string;
	public salesTeamId?: string;
	public signDate?: Date;
	public products: OrderLineModel[];
    
	constructor(){
		super();
		this.taskActionId = undefined;
		this.taskflowId = undefined;
		this.companyName = '';
		this.totalPrice = 0;
		this.business = '';
		this.sellerId = undefined;
		this.salesTeamId = undefined;
		this.signDate = undefined;
		this.products = [];
		
	}
	getProperties(){
		return QualificationCallOverviewModel.classProperties;
	}
}

